import React, { Suspense } from 'react';
import { createTheme, ThemeProvider } from '@mui/material';
import { useRoutes } from 'react-router-dom';
import './App.scss';
import routes from './routes';
import { SnackbarProvider } from 'notistack';
import GlobalMessage from './components/message/GlobalMessage';

function App() {
  const element = useRoutes(routes);
  const lightTheme = createTheme({
    typography: {
      htmlFontSize: 18,
      // fontSize: 14,
    },
    palette: {
      mode: 'light',
      primary: {
        main: '#3f51b5',
      },
      secondary: {
        main: '#f50057',
      },
      background: {
        default: '#fafafa',
        paper: '#fff',
      },
    },
  });
  return (
    <div id='App'>
      <ThemeProvider theme={lightTheme}>
        <SnackbarProvider anchorOrigin={{ horizontal: 'center', vertical: 'top' }}>
          <Suspense>{element}</Suspense>
          <GlobalMessage/>
        </SnackbarProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
